export { getWishlistServerAction } from 'next-flight-server-reference-proxy-loader?id=000861e83c1339b315726e57e7d4010b98980d27c2&name=getWishlistServerAction!'